export default __webpack_public_path__ + "static/media/section4Bg.3b95754c.png";